import { PageId } from '~/shared/constants/pagesConstants'

export const DIAGNOSIS_CORRECT_ANSWERS: Partial<Record<PageId, string>> = {
  [PageId.DIAGNOSIS_HEADACHE_ANATOMY_V2_1]: 'suboccipitals',
  [PageId.DIAGNOSIS_SHOULDER_ANATOMY_V2_1]: 'gallbladder',
  [PageId.DIAGNOSIS_HIP_ANATOMY_V2_1]: 'hipFlexors',
}
